var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getRole === '' && _vm.getCountry.id === 'ES')?_c('Step2a'):_c('Step2b')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }